var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('layout-default-new',[_c('div',[_c('h2',[_vm._v("Get Purchase Invoices")])]),_c('div',[_c('b-button',{on:{"click":_vm.refetch}},[_vm._v("Refetch")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }